module.exports = __webpack_public_path__ + "img/iphone.389d1290.png";